import * as React from 'react';

import SkipForNow from './skip_for_now';

import { requestPut, } from '../../../../../modules/request/index';
import { Input, } from '../../../../Shared/index';

const schoolVerificationSrc = `${window.postbuildEnv.CDN_URL}/images/onboarding/school_verification.svg`

const SchoolVerificationForm = ({ schoolName, }) => {
  const [verificationUrl, setVerificationUrl] = React.useState('')
  const [verificationReason, setVerificationReason] = React.useState('')

  function submitAdminInfo() {
    requestPut(
      `${window.postbuildEnv.DEFAULT_URL}/admin_infos`,
      {
        verification_url: verificationUrl,
        verification_reason: verificationReason
      },
      (body) => {
        window.location = '/finish_sign_up'
      }
    )
  }

  function onChangeVerificationUrl(e) {
    setVerificationUrl(e.target.value)
  }

  function onChangeVerificationReason(e) {
    setVerificationReason(e.target.value)
  }

  const submitButtonClassName = "quill-button-archived primary contained medium focus-on-light"
  let submitButton = <button className={`${submitButtonClassName} disabled`} disabled type="button">Submit</button>

  if (verificationUrl && verificationReason) {
    submitButton = <button className={submitButtonClassName} onClick={submitAdminInfo} type="button">Submit</button>
  }

  return (
    <React.Fragment>
      <img alt="" src={schoolVerificationSrc} />
      <h1><span>Please verify your connection to:</span><span className="school-name">{schoolName}</span></h1>
      <p className="sub-header">Quill is committed to securing the privacy of districts, schools, teachers, and students. Complete the form below to ensure we are providing you with the appropriate access.</p>
      <section className="user-account-section school-verification-section">
        <Input
          handleChange={onChangeVerificationUrl}
          helperText={`If you do not have a LinkedIn profile, please provide a link to another website that demonstrates your connection to ${schoolName}.`}
          id="verification-url"
          label="Please provide the URL of your LinkedIn profile"
          placeholder="Enter URL"
          showPlaceholderWhenInactive={true}
          value={verificationUrl}
        />
        <Input
          handleChange={onChangeVerificationReason}
          id="verification-reason"
          label={`Why do you want to be an admin for ${schoolName}?`}
          placeholder="Type an answer"
          showPlaceholderWhenInactive={true}
          value={verificationReason}
        />
      </section>
      <div className="button-wrapper">
        {submitButton}
      </div>
      <SkipForNow />
    </React.Fragment>
  )
}

export default SchoolVerificationForm
